import {LexicalEditor} from 'lexical';
import {$toggleLink, LinkAttributes} from '@lexical/link';
import {updateEditorSelection} from './common';
import {THyperlinkStates} from '../components/SideBar/parts/Hyperlink/hooks/types';

export const insertUrlContent = async (
    editor: LexicalEditor,
    hyperlinkState: THyperlinkStates
): Promise<void> => {
    return new Promise((_, reject) => {
        if (!editor) {
            reject('Editor instance is missing');
        }

        updateEditorSelection(editor, hyperlinkState.text || hyperlinkState.url, () =>
            $toggleLink(hyperlinkState.url, hyperlinkState as THyperlinkStates & LinkAttributes)
        );
    });
};
